import { useMemo } from 'react';
import type { NpsUser } from '@/shared/types/nps';
import { Label } from '@/shared/ui/label';
import { Combobox, type ComboboxOption } from '@/shared/ui/combobox';

interface Props {
  users: NpsUser[];
  value: string;
  onChange: (userId: string) => void;
  disabled?: boolean;
  hint?: string;
  id?: string;
}

/** Admin puro não é dono de pesquisa. Sem roles, permanece na lista. */
function isClientAccount(user: NpsUser): boolean {
  const roles = user.roles ?? [];
  if (roles.length === 0) return true;
  const pureAdmin = roles.includes('admin') && !roles.includes('org') && !roles.includes('user');
  return !pureAdmin;
}

/** Cliente NPS dono da pesquisa — só o master escolhe. */
export function SurveyOwnerSelect({
  users,
  value,
  onChange,
  disabled,
  hint = 'A pesquisa será criada na conta do cliente selecionado.',
  id = 'survey-owner',
}: Props) {
  const options = useMemo<ComboboxOption[]>(() => {
    return users.filter(isClientAccount).map((u) => ({
      value: u.id,
      label: `${u.name} ${u.last_name ?? ''}`.trim(),
      description: u.email,
    }));
  }, [users]);

  return (
    <div className="space-y-2">
      <Label htmlFor={id}>Cliente NPS</Label>
      <Combobox
        id={id}
        value={value}
        onChange={onChange}
        options={options}
        placeholder="Selecione o dono da pesquisa"
        searchPlaceholder="Buscar por nome ou e-mail"
        emptyLabel="Nenhum cliente encontrado."
        disabled={disabled}
      />
      <p className="text-xs text-muted-foreground">{hint}</p>
    </div>
  );
}
